import chalk from "chalk";

let verboseMode = false;

export function setVerbose(enabled: boolean): void {
  verboseMode = enabled;
}

export function verbose(message: string, ...args: unknown[]): void {
  if (verboseMode) {
    console.log(chalk.dim(`[verbose] ${message}`), ...args);
  }
}

export function info(message: string, ...args: unknown[]): void {
  console.log(chalk.cyan(message), ...args);
}

export function success(message: string, ...args: unknown[]): void {
  console.log(chalk.green(message), ...args);
}

export function warn(message: string, ...args: unknown[]): void {
  console.log(chalk.yellow(message), ...args);
}

export function error(message: string, ...args: unknown[]): void {
  console.error(chalk.red(message), ...args);
}
